import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  keyTopicsWrapper: {
    display: 'flex',
    gap: 13,
  },
  keyTopicsItem: {
    display: 'flex',
    gap: 5,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },

  gridWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
    justifyContent: 'flex-start',

    paddingLeft: 53,
    paddingRight: 53,
    width: '100%',
  },
  gridItem: {
    backgroundColor: '#EEEEEE',
    borderRadius: 4,
    overflow: 'hidden',

    width: '24%',
    height: 160,

    paddingTop: 10,
    paddingBottom: 20,
    paddingHorizontal: 10,
  },
  itemTitle: {
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 11,
    marginBottom: 10,
    textAlign: 'center',
  },
  smallText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
  },
});
